export const PROMOTIONS = [
    {
      id: 0,
      name: 'Special Event Cakes',
      image: '/assets/images/special2.png',
      label: 'New',
      price: '19.99',
      featured: true,
      description: 'Special event cakes featuring perfectly smooth, satin-finished fondant. This three-tiered wedding cake packs a serious visuals. The dramatic theme is brightened with bursts of blush rose petals and yellow leaves adding a slight edge to romantic scene.'
    }
  ];